import React from "react";
import styles from "./Checkbox.module.css";

export default function Checkbox({
                                     checked = false,
                                     onChange = () => {},
                                     label = "",
                                     className = "",
                                 }) {
    return (
        <label className={`${styles.checkboxLabel} ${className}`}>
            <input
                type="checkbox"
                checked={checked}
                onChange={(e) => onChange(e.target.checked)}
                className={styles.checkboxInput}
            />
            <span className={styles.checkboxText}>{label}</span>
        </label>
    );
}
